import { type QueryOptions } from '@tanstack/query-core'

import { type ShipmentCategoryEntity } from '@/libs/api'

import { fetchShipmentCategories } from '../api/fetch-shipment-categories'
import { shipmentCategoriesQueryKeys } from '../query-keys'

/**
 * Select用の配送種別一覧のQueryOptionsを返す
 * データは全件取得
 */
export const getShipmentCategoriesSelectQueryOptions = (
  tenantKey: string,
  dcId?: number,
  shippingDate?: string
): Required<
  Pick<QueryOptions<ShipmentCategoryEntity[]>, 'queryKey' | 'queryFn'>
> => {
  const query = { enable: true, ...(shippingDate ? { shippingDate } : {}) }
  return {
    queryKey: shipmentCategoriesQueryKeys.select(tenantKey, dcId, shippingDate),
    queryFn: async ({ signal }) => {
      // APIから全データを取得（現在の実装では上限なし）
      const { data } = await fetchShipmentCategories(
        {
          tenantKey,
          query,
          dcId
        },
        signal
      )

      return data
    }
  }
}
